var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E77B7B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.6693C13.4547 20.6693 12.9333 20.4526 11.8913 20.0199C9.29733 18.9426 8 18.4039 8 17.4979V11.1659M14 20.6693C14.5453 20.6693 15.0667 20.4526 16.1087 20.0199C18.7027 18.9426 20 18.4039 20 17.4979V11.1659M14 20.6693V14.1153M8 11.1659C8 11.5679 8.53467 11.8226 9.60333 12.3306L11.55 13.2573C12.7533 13.8293 13.3533 14.1159 14 14.1159C14.6467 14.1159 15.2467 13.8293 16.45 13.2573L18.3967 12.3306C19.4653 11.8226 20 11.5679 20 11.1659M8 11.1659C8 10.7633 8.53467 10.5086 9.60333 10.0006L11 9.33594M20 11.1659C20 10.7633 19.4653 10.5093 18.3967 10.0013L17 9.33594M10 14.7706L11.3333 15.4259M14.0027 7.33594V12.0026M14.0027 12.0026C14.178 12.0053 14.3507 11.8826 14.4787 11.7326L15.3333 10.7106M14.0027 12.0026C13.8333 12.0006 13.662 11.8786 13.5267 11.7326L12.6667 10.7106",
    stroke: "#E77B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedIcon);
export default __webpack_public_path__ + "static/media/ReceivedIcon.5ff6561004ef584bafc877785a4555df.svg";
export { ForwardRef as ReactComponent };